import React from 'react';

import Defaults from '../layout/Defaults.jsx';
import LocalStorage from '../common/LocalStorage.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import { ContentContainer } from '../common/Popup.jsx';

const minPopupDelay = 5000;

function SubscribePopup(props) {
    const [visible, setVisible] = React.useState(props.builder || props.visible);

    let timerHandle;
    const resetTimer = () => {
        if (timerHandle) {
            clearTimeout(timerHandle);
            timerHandle = undefined;
        }
    }
    const updatePopupShown = () => {
        if (cookie.getCookie(cookie._subscribe).length == 0) {
            cookie.setCookie(cookie._subscribe, 'shown', 7);
        }
        LocalStorage.remove(LocalStorage.keys.subscribePopup);
    }
    React.useEffect(() => {
        if (props.builder || timerHandle || cookie.getCookie(cookie._subscribe).length > 0 || props.visible || !props.config || props.config.popupDelay == null) {
            if (!props.builder && props.visible) {
                updatePopupShown();
                resetTimer();
            }
            return;
        }
        let start = LocalStorage.get(LocalStorage.keys.subscribePopup);
        if (!start) {
            start = new Date().getTime();
            LocalStorage.put(LocalStorage.keys.subscribePopup, start);
        }
        const now = new Date().getTime();
        const delay = props.config.popupDelay * 1000;
        const minDelay = Math.min(delay, minPopupDelay);
        let timeout = delay - (now - start);
        if (timeout < minDelay) {
            timeout = minDelay;
        }
        timerHandle = setTimeout(() => {
            if (cookie.getCookie(cookie._subscribe).length == 0) {
                setVisible(true);
            }
            updatePopupShown();
            resetTimer();
        }, timeout)
        return () => {
            if (timerHandle) {
                clearTimeout(timerHandle);
            }
        }
    }, []);

    if (!visible) {
        return null;
    }
    const handleClose = function () {
        if (props.onClose) {
            props.onClose();
        }
        setVisible(false);
        resetTimer();
    }
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        contentConfig = props.config && props.config.documents && props.config.documents[PageType.Popup.Subscribe];
    }
    if (!contentConfig) {
        contentConfig = Defaults.PageConfig[PageType.Popup.Subscribe](props.config);
    }
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        switch (d.type.value) {
            case Name.Block.CloseButton:
                return { onClick: handleClose };
            case Name.Block.SubscribeForm.Container:
                return { editor: false, inPopup: true };
        }
    }
    return <ContentContainer {...props} blockPropsHandler={handleBlockProps} className="ol--subscribe" contentConfig={contentConfig} />
}

export default SubscribePopup;